import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { stripTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-sand border-y border-sand-deep" data-id="element-282" data-mp="3sq1wvzm5442a">
      <div className="max-w-7xl mx-auto px-4" data-id="element-283" data-mp="3ssent29vlorh">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-284" data-mp="3nzbosembxn3w">
          {stripTestimonials.map((testimonial, index) => <motion.figure key={testimonial.initials} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.3,
          delay: index * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-sand-deep p-6 rounded-2xl shadow-sm flex flex-col h-full" data-id="element-285" data-mp="5kkkx06b6o5f" data-mpi={index}>
              <div className="flex gap-1 text-copper mb-4" aria-label="5 out of 5 stars" data-id="element-286" data-mp="2cd3m1x15b1fr">
                {[...Array(5)].map((_, star) => <StarIcon key={star} size={16} fill="currentColor" aria-hidden="true" data-id="element-287" data-mp="gdj60l2h0g66" data-mpi={star} />)}
              </div>
              <blockquote className="text-charcoal italic mb-6 text-sm leading-relaxed" data-id="element-288" data-mp="q4vud2p28o7g">
                &quot;{testimonial.text}&quot;
              </blockquote>
              <figcaption className="flex items-center gap-3 mt-auto" data-id="element-289" data-mp="101s7xmttg0iv">
                <div className="w-10 h-10 rounded-full bg-charcoal border border-orange flex items-center justify-center text-orange font-bold text-sm shrink-0" data-id="element-290" data-mp="1044pvzzkqavx">
                  {testimonial.initials}
                </div>
                <div data-id="element-291" data-mp="35vrwhpiawn11">
                  <div className="font-bold text-charcoal text-sm" data-id="element-292" data-mp="35wbe1541h9ej">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-warmgray" data-id="element-293" data-mp="3aulark5ewi29">{testimonial.role}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}